import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { PedidoPecasFiltroService } from './pedido-pecas-filtro.service';
import { PedidoPecasServiceService } from './pedido-pecas-service.service';

@Component({
  selector: 'app-pedido-pecas',
  templateUrl: './pedido-pecas.component.html',
  styleUrls: ['./pedido-pecas.component.scss']
})
export class PedidoPecasComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  pedidoStatus = [];
  cols: any[];
  _selectedColumns: any[];
  dados: any[] = [];
  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  filtrosDealers: FiltroDealers;
  cargaTela: boolean;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Cód. Item": "estoque.pedidoPecas.grid.codItem",
    "Qtd. Pedidos": "estoque.pedidoPecas.grid.quantidadePedido",
    "Data do Pedido": "estoque.pedidoPecas.grid.dataPedido",
    "Nº Pedido Dealer": "estoque.pedidoPecas.grid.numeroInterno",
    "Status": "estoque.pedidoPecas.grid.statusPedido",
    "Nº Pedido Fabrica": "estoque.pedidoPecas.grid.numeroFornecedor",
    "Qtd. Aprovada": "estoque.pedidoPecas.grid.quantidadeAprovada",
    "Data de Entrada": "estoque.pedidoPecas.grid.dataEntrada",
  }

  constructor(private service: PedidoPecasServiceService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: PedidoPecasFiltroService,
    private exportExcelSerivce: ExportExcelService,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'Controle de Propostas';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      pedido_status: [''],
      codigo_item: [''],
      numero_interno: [''],
      numero_fornecedor: ['']
    });
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    this.preencherStatus();
    this.loading = true;

    this.cols = [
      { field: 'codItem', header: 'estoque.pedidoPecas.grid.codItem', headerBr: 'Cód. Item', headerGb: 'Item code', width: '120px' },
      { field: 'quantidadePedido', header: 'estoque.pedidoPecas.grid.quantidadePedido', headerBr: 'Quantidade Pedidos', headerGb: 'Quantity Ordered', width: '120px' },
      { field: 'dataPedido', header: 'estoque.pedidoPecas.grid.dataPedido', headerBr: 'Data do Pedido', headerGb: 'Order Date', width: '120px' },
      { field: 'numeroInterno', header: 'estoque.pedidoPecas.grid.numeroInterno', headerBr: 'Numero Pedido Dealer', headerGb: 'Nº Dealer Order', width: '120px' },
      { field: 'statusPedido', header: 'estoque.pedidoPecas.grid.statusPedido', headerBr: 'Status', headerGb: 'Status', width: '100px' },
      { field: 'numeroFornecedor', header: 'estoque.pedidoPecas.grid.numeroFornecedor', headerBr: 'Numero Pedido Fabrica', headerGb: 'Nº Factory Order', width: '120px' },
      { field: 'quantidadeAprovada', header: 'estoque.pedidoPecas.grid.quantidadeAprovada', headerBr: 'Quantidade Aprovada', headerGb: 'Approved Quantity', width: '120px' },
      { field: 'dataEntrada', header: 'estoque.pedidoPecas.grid.dataEntrada', headerBr: 'Data de Entrada', headerGb: 'Entry Date', width: '120px' },
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherStatus() {
    this.pedidoStatus = [
      { nome: 'Preparando', valor: "C" },
      { nome: 'Em trânsito', valor: "A" },
      { nome: 'Entregue', valor: "E" }
    ]
  }

  private getAll() {
    this.service.getLista(this.f.dealers.value, this.f.data_inicial.value, this.f.data_final.value, 
      this.f.pedido_status.value, this.f.codigo_item.value, this.f.numero_interno.value, 
      this.f.numero_fornecedor.value).subscribe(dados => {

      this.dados = dados.pedidos;
      this.loading = false;
      this.cargaTela = false;
    });

    console.log(this.f.data_inicial.value);
    console.log(this.f.data_final.value);
    console.log(this.f.dealers.value);
    console.log(this.f.pedido_status.value);
    console.log(this.f.codigo_item.value);
    console.log(this.f.numero_interno.value);
    console.log(this.f.numero_fornecedor.value);
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.loading = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.pedido_status.value
      || this.f.codigo_item.value
      || this.f.numero_interno.value
      || this.f.numero_fornecedor.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.pedido_status.setValue('');
    this.f.codigo_item.setValue('');
    this.f.numero_interno.setValue('');
    this.f.numero_fornecedor.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {
    if (value.status == 'Vendido') {
      return this.translate.currentLang == "br" ? value.status = "Vendido" : value.status = "Sold";
    }

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "estoque.pedidoPecas.grid.codItem") {
      return this.translate.currentLang == "br" ? "Cód. Item" : "Dealer Code";
    }
    if (item == "estoque.pedidoPecas.grid.quantidadePedido") {
      return this.translate.currentLang == "br" ? "Qtd. Pedidos" : "Quantity Ordered";
    }
    if (item == "estoque.pedidoPecas.grid.dataPedido") {
      return this.translate.currentLang == "br" ? "Data do Pedido" : "Order Date";
    }
    if (item == "estoque.pedidoPecas.grid.numeroInterno") {
      return this.translate.currentLang == "br" ? "Nº Pedido Dealer" : "Nº Dealer Order";
    }
    if (item == "estoque.pedidoPecas.grid.statusPedido") {
      return "Status";
    }
    if (item == "estoque.pedidoPecas.grid.numeroFornecedor") {
      return this.translate.currentLang == "br" ? "Nº Pedido Fabrica" : "Nº Factory Order";
    }
    if (item == "estoque.pedidoPecas.grid.quantidadeAprovada") {
      return this.translate.currentLang == "br" ? "Qtd. Aprovada" : "Approved Quantity";
    }
    if (item == "estoque.pedidoPecas.grid.dataEntrada") {
      return this.translate.currentLang == "br" ? "Data de Entrada" : "Entry Date";
    }
  }

  protected translateField(item) {
    return item;
  }

  exportExcel() {
    let registros = [];

    this.service.getLista(this.f.dealers.value, this.f.data_inicial.value, this.f.data_final.value, 
      this.f.pedido_status.value, this.f.codigo_item.value, this.f.numero_interno.value, 
      this.f.numero_fornecedor.value).subscribe(dados => {

        registros = dados.pedidos;

        registros.forEach(dados => {
          dados.dataPedido = this.formatDateTime(new Date(dados.dataPedido));
          dados.dataEntrada = this.formatDateTime(new Date(dados.dataEntrada));
        });

        if (registros.length > 0) {
          this.exportExcelSerivce.nomeModulo = "Restrição LGPD";
          this.exportExcelSerivce.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this.cols.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
    });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

  formatDateTime(value: any): string {
    let pad: Function = (val: number) => {
      return val < 10 ? '0' + val : val;
    };
    return value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate())
      + ' ' + pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':' + pad(value.getSeconds());
  }

}
